import Link from "next/link";
import NxtImage from "@sharedComponents/image";

import stadiumLogo from "@images/svg/stadium-logo.svg";

const mainContainer = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  fontFamily: "Overpass",
};

const container = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  maxWidth: "1124px",
  padding: "0px 24px",
  textAlign: "center",
};

const imgBox = {
  width: "300px",
  height: "60px",
  position: "relative",
};

const h2 = {
  fontSize: "32px",
  fontWeight: "normal",
  marginBottom: "0",
};

const text = {
  fontSize: "20px",
  fontWeight: "300",
  color: "#6c757d",
  paddingBottom: "32px",
  marginBottom: "32px",
};

const ErrorComponent = () => (
  <div style={mainContainer}>
    <div style={container}>
      <Link href={"/"} passHref legacyBehavior prefetch={false}>
        <div style={imgBox}>
          <NxtImage src={stadiumLogo} layout="fill" />
        </div>
      </Link>

      <h2 style={h2}>Something went wrong!</h2>

      <p style={text}>
        Our team has been notified. Meanwhile, you may refresh the page or try again.
      </p>
    </div>
  </div>
);

export default ErrorComponent;
